export default __webpack_public_path__ + "static/media/art-4-beetroot-lg.6bdb9e3d.jpg";